/* global axios */
import ApiClient from './ApiClient';

class CrmDashboardAPI extends ApiClient {
  constructor() {
    super('rankings', { accountScoped: true });
  }

  getMetrics({ startDate, endDate } = {}) {
    return axios.get(this.url, {
      params: { start_date: startDate, end_date: endDate },
    });
  }

  getAdvancedStats(params = {}) {
    return axios.get(`${this.url}/advanced`, { params });
  }

  getTodayMetrics(params = {}) {
    return axios.get(`${this.url}/today_metrics`, { params });
  }

  getAnuncioStats(params = {}) {
    return axios.get(`${this.url}/anuncio_stats`, { params });
  }

  getLeadDrilldown(params = {}) {
    return axios.get(`${this.url}/lead_drilldown`, { params });
  }

  getCalendarEvents(params = {}) {
    return axios.get(`${this.url}/calendar_events`, { params });
  }
}

export default new CrmDashboardAPI();
